import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";

export class TicketOfferChangeAction extends BaseAction<void, { indexValue: number }> {

    override async run(): Promise<void> {
        try {
            const { indexValue } = this.params!;
            updateRecoilState("currentOfferIndexTicketAtom", indexValue);
            updateRecoilState("currentLegIndexTicketAtom", 0);
            updateRecoilState("currentPassengerTicketAtom", 0);
        } catch (error) {
            console.error("Error in TicketOfferChangeAction:", error);
        }
    }
}

// Create a singleton instance
export const ticketOfferChangeAction = new TicketOfferChangeAction(); 